export default __webpack_public_path__ + "static/column-span-dark-6f3256aac78cfffc0a6cc4e39d85dbdc.png";